/* eslint-disable react/no-did-update-set-state,no-param-reassign,react/prop-types */
import _ from 'lodash';
import React, { Component } from 'react';
import Button from '../views/StyledButton';
import TableGrid from './TableGrid';
import Input from './InputBorderless';
import VocabularyListTermObject from './../store/models/VocabularyListTermObject';
import { HelpText } from './typography';
import CenterFlex from './CenterFlex';
import { MAX_WEIGHT } from '../appConstants';

function numSoundsLike(sl, min = 0) {
  if (!sl) {
    return Math.max(sl, min);
  }
  if (Array.isArray(sl)) {
    return Math.max(sl.length, min);
  }
  if (typeof sl === 'string') {
    return Math.max(sl.split('\n').length, min);
  }
  return Math.max(0, min);
}

function soundsLikeToString(sl) {
  if (!sl) {
    return '';
  }
  if (Array.isArray(sl)) {
    return sl.join('\n');
  }
  if (typeof sl === 'string') {
    return sl;
  }
  return '';
}

class PredefVocabTermEditor extends Component {
  constructor(props) {
    super(props);
    const keywords = _.get(props, 'keywords', []);
    const defaultWeight = _.get(props, 'defaultWeight', 0);
    const terms = VocabularyListTermObject.termsToData(keywords, defaultWeight);

    this.state = { newTerm: new VocabularyListTermObject('', defaultWeight), keywords: terms };
    this.debouncedOnChange = _.debounce(this.onChange, 1000);
  }

  updateField(event, field, term) {
    const keywords = [...this.state.keywords];
    if (!term) {
      return;
    }

    let value;
    if (typeof event === 'object') {
      value = _.get(event, 'target.value', '');
    }

    if (field === 'showSoundsLike') {
      this.onChange();
      term.showSoundsLike = !term.showSoundsLike;
    } else if (field === 'soundsLike') {
      term.soundsLike = value.split('\n');
    } else {
      term[field] = value;
    }

    this.setState(
      { keywords: [...keywords] },
      () => this.debouncedOnChange(),
    );
  }

  onChange() {
    // convert the array of terms back to a csv text value
    this.props.onChange(_([...this.state.keywords, this.state.newTerm])
      .compact()
      .map(item => item.toCSV())
      .sortBy()
      .uniq()
      .value()
      .join('\n'));
  }

  savedTermRow(termDef, rowIndex) {
    return this._termRow(
      rowIndex,
      termDef,
      (event, field) => this.updateField(event, field, termDef),
      (event, field) => this.termFieldPress(event, field, rowIndex),
    );
  }

  termFieldPress(event, field, index) {
    if (event.key === 'Enter') {
      const nextIndex = index + 1;
      const id = `${nextIndex}_${field}`;

      const nextElement = document.getElementById(id);
      if (nextElement) {
        nextElement.focus();
      } else {
        const ele = document.getElementById(`term-new_${field}`);
        if (ele) ele.focus();
      }
    }
  }

  placeHolderHack() {
    Array.from(document.getElementsByClassName('sounds-like-textarea'))
      .forEach((elm) => {
        elm.placeholder = 'SoundsLike term\n(One per row)';
      });
  }

  componentDidMount() {
    this.placeHolderHack();
  }

  componentDidUpdate(prevProps) {
    if (_.isEqual(prevProps.keywords, this.props.keywords)) {
      return;
    }
    const propKWset = new Set(VocabularyListTermObject.termsToData(this.props.keywords).map(t => t.term));
    const stateKWset = new Set(this.state.keywords.map(t => t.term));
    propKWset.add('');
    stateKWset.add('');
    stateKWset.add(this.state.newTerm.term);

    if (!_.isEqual(propKWset, stateKWset)) {
      // assume a reset or import
      this.setState({
        newTerm: new VocabularyListTermObject('', this.props.defaultWeight),
        keywords: VocabularyListTermObject.termsToData(this.props.keywords),
      });
    }
    this.placeHolderHack();
  }

  saveNewTerm() {
    const keywords = [...this.state.keywords, this.state.newTerm];
    this.setState({ newTerm: new VocabularyListTermObject('', this.props.defaultWeight), keywords });
  }

  newTermPress(event, field) {
    if (event.key === 'Enter') {
      this.saveNewTerm();
      requestAnimationFrame(() => {
        const ele = document.getElementById(`term-new_${field}`);
        if (ele) ele.focus();
      });
    }
  }

  newTermChange(event, field) {
    const value = (typeof event === 'string') ? event : _.get(event, 'target.value', '');
    const newTerm = new VocabularyListTermObject(this.state.newTerm);
    newTerm.showSoundsLike = this.state.newTerm.showSoundsLike;

    if (field === 'showSoundsLike') {
      this.onChange();
      newTerm.showSoundsLike = !this.state.newTerm.showSoundsLike;
    } else if (field === 'soundsLike') {
      // eslint-disable-next-line no-param-reassign
      newTerm.soundsLike = value.split('\n');
    } else {
      // eslint-disable-next-line no-param-reassign
      newTerm[field] = value;
    }

    this.setState(
      { newTerm },
      () => this.debouncedOnChange(),
    );
  }

  newTermRow(rowIndex) {
    return this._termRow(
      rowIndex,
      this.state.newTerm,
      (event, field) => this.newTermChange(event, field),
      (event, field) => this.newTermPress(event, field),
      'term-new',
    );
  }

  _termRow(key, termDef, onChange, onPress, id) {
    return (
      <tr key={key} data-react={key}>
        <td>
          <Input
            type="text"
            id={`${id || key}_term`}
            autoComplete="off"
            placeholder="term or phrase"
            value={termDef.term}
            onKeyPress={event => onPress(event, 'term')}
            onChange={event => onChange(event, 'term')}
          />
        </td>
        <td style={({ width: 100 })}>
          <Input
            type="number"
            min={0}
            max={MAX_WEIGHT}
            id={`${id || key}_weight`}
            value={termDef.weight}
            onKeyPress={event => onPress(event, 'weight')}
            onChange={event => onChange(event, 'weight')}
          />
        </td>
        <td>
          {termDef.showSoundsLike && <Input.TextArea
            rows={numSoundsLike(termDef.soundsLike)}
            className="sounds-like-textarea"
            value={soundsLikeToString(termDef.soundsLike)}
            onChange={event => onChange(event, 'soundsLike')}
          />}
          {!termDef.showSoundsLike && numSoundsLike(termDef.soundsLike, 0)}
        </td>
        <td style={({ width: 50 })}><Button
          onClick={(event) => {
             onChange(event, 'showSoundsLike');
             requestAnimationFrame(() => {
               this.placeHolderHack();
             });
          }}
          type="primary"
          icon="plus"
          size="small"
          shape="circle"
        />
        </td>
      </tr>
    );
  }

  render() {
    return (
      <TableGrid style={({ width: '100%' })}>
        <thead>
          <tr>
            <th style={({ width: 200 })}>Term</th>
            <th style={({ width: 50 })}>Weight</th>
            <th>SoundsLike</th>
          </tr>
        </thead>
        <tbody>
          {(this.state.keywords).map(((term, rowIndex) => this.savedTermRow(term, rowIndex)))}
          {this.newTermRow(this.state.keywords.length)}
          <tr>
            <td colSpan="4">
              <CenterFlex>
                <HelpText style={({ marginRight: '1rem' })}>
                  Use the <b>Enter</b> Key in last keyword field to
                </HelpText>
                <Button size="small" onClick={() => this.saveNewTerm()}>
                Add A Row
                </Button>
              </CenterFlex>
            </td>
          </tr>
        </tbody>
      </TableGrid>
    );
  }
}

export default PredefVocabTermEditor;
